import {
  DatePipe,
  isPlatformBrowser,
  NgClass
} from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  PLATFORM_ID,
  Signal,
  signal
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { RendezVous } from '../../../../../core/model/rendez-vous.model';
import { ConfirmCancelSeanceComponent } from '../../confirm-cancel-seance/confirm-cancel-seance.component';
import { ConfirmCancelSpaComponent } from '../../confirm-cancel-spa/confirm-cancel-spa.component';
import { emulateClick } from '../../core/a11y';
import { DrawerService } from '../../drawer/drawer.service';
import { ICalendarEvent } from '../../shared/add-calendar/model/calendar-event.model';
import { CalendarTypeEnum } from '../../shared/add-calendar/model/calendar-type.enum';
import { AddToCalendarService } from '../../shared/add-calendar/service/add-calendar.service';
import {
  Custom,
  DatePickerComponent
} from '../../shared/date-picker/date-picker.component';
import { AutoCloseDirective } from '../../shared/directives/auto-close.directive';
import { ByPassPipeUrl } from '../../shared/pipes/by-pass-url.pipe';
import { AccountService } from '../../shared/services/account.service';
import { CenterService } from '../../shared/services/center.service';

@Component({
  selector: 'app-next-appointment',
  templateUrl: 'next-appointment.component.html',
  imports: [
    AutoCloseDirective,
    DatePickerComponent,
    DatePipe,
    NgxTolgeeModule,
    NgClass,
    ByPassPipeUrl
  ]
})
export class NextAppointmentComponent {
  platformId = inject(PLATFORM_ID);
  addToCalendarService = inject(AddToCalendarService);
  accountService = inject(AccountService);
  centerService = inject(CenterService);
  drawerService = inject(DrawerService);
  rendezVous = signal<RendezVous[]>([]);
  selectedDate = signal<string | null>(null);
  customs: Signal<Custom<Date>[]> = computed(() => {
    const rendezVous = this.rendezVous();
    return rendezVous.map(rv => {
      const [ year, month, day ] = rv.date.split('-').map(Number);
      const date = new Date(Date.UTC(year, month - 1, day))
      return {
        from: date,
        to: date,
        css: [ 'border', '!text-white', '!bg-bleuCaliceo-300' ],
      }
    });
  });
  protected readonly emulateClick = emulateClick;
  protected readonly ConfirmCancelSeanceComponent = ConfirmCancelSeanceComponent
  protected readonly ConfirmCancelSpaComponent = ConfirmCancelSpaComponent

  constructor() {
    effect(async () => {
      this.accountService.dataChanged();
      const now = new Date();
      const future = new Date()
      future.setFullYear(future.getFullYear() + 3);
      const rendezVous = isPlatformBrowser(this.platformId) ?
        await this.accountService.rendezVous(
          now.toISOString().slice(0, 10),
          future.toISOString().slice(0, 10)
        ) :
        [];
      for (const rdv of rendezVous) {
        const center = this.centerService.withErpId(rdv.centerErpId);
        const event: ICalendarEvent = {
          title: rdv.label,
          start: new Date(`${rdv.date}T${rdv.start}+02:00`),
          end: new Date(`${rdv.date}T${rdv.end}+02:00`),
          duration: 0,
        };
        const address = center.address;
        rdv.calendar = {
          google: this.addToCalendarService.getHrefFor(CalendarTypeEnum.google, {
            ...event,
            address: address.replaceAll('\n', ', ')
          }),
          ical: this.addToCalendarService.getHrefFor(CalendarTypeEnum.iCalendar, {
            ...event,
            address: JSON.stringify(address).replaceAll('"', '')
          }),
          outlook: this.addToCalendarService.getHrefFor(CalendarTypeEnum.outlookLive, {
            ...event,
            address: address.replaceAll('\n', ', ')
          }),
        }
      }
      this.rendezVous.set(rendezVous);
    });
  }

  setSelectedDate(date?: Date): void {
    if (!date) {
      this.selectedDate.set(null);
      return
    }
    this.selectedDate.set(date.toISOString().slice(0, 10));
  }

  rendezVousState(rv: RendezVous): string {
    const today = new Date().toISOString().slice(0, 10);
    if (rv.date < today) {
      return 'done';
    }
    if (rv.waiting) {
      return 'waiting'
    }
    return 'confirmed'

  }
}
